export default [
  { id: "L", description: "Light" },
  { id: "M", description: "Medium" },
  { id: "H", description: "Heavy" },
];
